export default "__VITE_ASSET__DlX41Ypa__"